import Axios from 'axios';
import moment from 'moment';
import {checkAppraisalRouter, encryptData, localStorageKeyValue, setLocalStorageValue} from 'utils/handler';
import {baseUrl, requestHeader} from '../../config';
import store from '../../store/store';
import {UserPrivileges} from '../../views/types/user.types';
import {CatchReturnError} from './actionHandler';
import * as types from './types';
// requestHeader.Authorization = localStorage.getItem('saw-token') || ""
export const getUserListAction = (filters: {search: string; filterBy: string; filterType: string; sortBy: string; sortType: string; limit: number; page: number}) => {
  let getUserURL =
    baseUrl +
    `/users?search=${filters.search}&limit=${filters.limit}&page=${filters.page}
  &filterBy=${filters.filterBy}&filterType=${filters.filterType}&sortBy=${filters.sortBy}&sortType=${filters.sortType}`;
  return Axios.get(getUserURL, requestHeader)
    .then(async (res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getUserDetails = (userUID: string) => {
  return Axios.get(baseUrl + '/getUserDetails/' + userUID, requestHeader)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const updateUserPrivilegesAction = (payload: UserPrivileges, userUID: string) => {
  return Axios.patch(baseUrl + '/updatePrivileges/' + userUID, payload, requestHeader)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const createUserAction = (payload: any) => {
  return Axios.post(baseUrl + '/createUser', payload, requestHeader)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const updateUserAction = (payload: any, UID: string) => {
  return Axios.patch(baseUrl + '/users/' + UID, payload, requestHeader)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getRegistrarList = () => {
  return Axios.get(baseUrl + '/getRegistrarList', requestHeader)
    .then(async (res) => {
      let response = res['data'];
      store.dispatch({type: types.REGISTRAR_LIST, payload: response});
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const getRolesAction = () => {
  return Axios.get(baseUrl + '/roles', requestHeader)
    .then(async (res) => {
      let response = res['data'];
      store.dispatch({type: types.ROLE_LIST, payload: response});
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const getMyProfile = async () => {
  return Axios.get(baseUrl + '/myProfile', requestHeader)
    .then(async (res) => {
      let response = res['data'];
      if (response) {
        setLocalStorageValue(localStorageKeyValue.userUID, response.UID);
        setLocalStorageValue(localStorageKeyValue.myProfile, encryptData(response));
      }
      if (checkAppraisalRouter() && !response.phone) {
        store.dispatch({type: types.UPDATE_PROFILE_WINDOW, payload: true})
      }
      store.dispatch({type: types.GET_MY_PROFILE, payload: response});
      let timeStamp: any = moment();
      localStorage.setItem('lastTimeStamp', timeStamp);
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const userLogoutAction = () => {
  Axios.get(baseUrl + '/logout', requestHeader)
    .then(async (res) => { })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getIntegrationLink = () => {
  return Axios.get(baseUrl + '/getIntegrationLink', requestHeader)
    .then((res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const sendAppraisalCertificate = (payload: {email: string; domainName: string; name?: string}) => {
  return Axios.post(baseUrl + '/sendAppraisalCertificate', payload, requestHeader)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const deleteUserAction = (UID: string) => {
  return Axios.delete(baseUrl + '/users/' + UID, requestHeader)
    .then(async (res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

// export const checkMyDomain = (domainName: string) => {
//   return function action(dispatch: AppDispatch) {
//     return Axios.get(baseUrl + '/user/checkMyDomain?domainName=' + domainName, requestHeader).then(res => {
//       let response = res['data']
//         dispatch({ type: types.ch, payload: response.user })
//       return response
//     }).catch(err => {
//       return CatchReturnError(err)
//     })
//   }
// };

export const updateMyProfile = (payload: any) => {
  payload.website = payload.website || '';
  return Axios.patch(baseUrl + '/myProfile', payload, requestHeader)
    .then((res) => {
      let response = res['data'];
      getMyProfile();
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

// export const updateProfile = (payload: any) => {
//   return function action(dispatch: AppDispatch) {
//     dispatch({ type: types.GET_MY_PROFILE, payload })
//   }
// };


